{
  "opcodes": {
    "0x00": {
      "instruction": "BRK",
      "mode": "implied",
      "bytes": 1,
      "cycles": 7
    },
    "0x01": {
      "instruction": "ORA",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0x02": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x03": {
      "instruction": "SLO",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 8
    },
    "0x04": {
      "instruction": "NOP",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x05": {
      "instruction": "ORA",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x06": {
      "instruction": "ASL",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x07": {
      "instruction": "SLO",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x08": {
      "instruction": "PHP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 3
    },
    "0x09": {
      "instruction": "ORA",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x0A": {
      "instruction": "ASL",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x0B": {
      "instruction": "ANC",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x0C": {
      "instruction": "NOP",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x0D": {
      "instruction": "ORA",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x0E": {
      "instruction": "ASL",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x0F": {
      "instruction": "SLO",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x10": {
      "instruction": "BPL",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0x11": {
      "instruction": "ORA",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0x12": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x13": {
      "instruction": "SLO",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 8
    },
    "0x14": {
      "instruction": "NOP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x15": {
      "instruction": "ORA",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x16": {
      "instruction": "ASL",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x17": {
      "instruction": "SLO",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x18": {
      "instruction": "CLC",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x19": {
      "instruction": "ORA",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x1A": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x1B": {
      "instruction": "SLO",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 7
    },
    "0x1C": {
      "instruction": "NOP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x1D": {
      "instruction": "ORA",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x1E": {
      "instruction": "ASL",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x1F": {
      "instruction": "SLO",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x20": {
      "instruction": "JSR",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x21": {
      "instruction": "AND",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0x22": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x23": {
      "instruction": "RLA",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 8
    },
    "0x24": {
      "instruction": "BIT",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x25": {
      "instruction": "AND",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x26": {
      "instruction": "ROL",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x27": {
      "instruction": "RLA",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x28": {
      "instruction": "PLP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 4
    },
    "0x29": {
      "instruction": "AND",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x2A": {
      "instruction": "ROL",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x2B": {
      "instruction": "ANC",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x2C": {
      "instruction": "BIT",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x2D": {
      "instruction": "AND",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x2E": {
      "instruction": "ROL",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x2F": {
      "instruction": "RLA",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x30": {
      "instruction": "BMI",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0x31": {
      "instruction": "AND",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0x32": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x33": {
      "instruction": "RLA",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 8
    },
    "0x34": {
      "instruction": "NOP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x35": {
      "instruction": "AND",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x36": {
      "instruction": "ROL",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x37": {
      "instruction": "RLA",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x38": {
      "instruction": "SEC",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x39": {
      "instruction": "AND",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x3A": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x3B": {
      "instruction": "RLA",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 7
    },
    "0x3C": {
      "instruction": "NOP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x3D": {
      "instruction": "AND",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x3E": {
      "instruction": "ROL",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x3F": {
      "instruction": "RLA",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x40": {
      "instruction": "RTI",
      "mode": "implied",
      "bytes": 1,
      "cycles": 6
    },
    "0x41": {
      "instruction": "EOR",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0x42": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x43": {
      "instruction": "SRE",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 8
    },
    "0x44": {
      "instruction": "NOP",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x45": {
      "instruction": "EOR",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x46": {
      "instruction": "LSR",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x47": {
      "instruction": "SRE",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x48": {
      "instruction": "PHA",
      "mode": "implied",
      "bytes": 1,
      "cycles": 3
    },
    "0x49": {
      "instruction": "EOR",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x4A": {
      "instruction": "LSR",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x4B": {
      "instruction": "ALR",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x4C": {
      "instruction": "JMP",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 3
    },
    "0x4D": {
      "instruction": "EOR",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x4E": {
      "instruction": "LSR",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x4F": {
      "instruction": "SRE",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x50": {
      "instruction": "BVC",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0x51": {
      "instruction": "EOR",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0x52": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x53": {
      "instruction": "SRE",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 8
    },
    "0x54": {
      "instruction": "NOP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x55": {
      "instruction": "EOR",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x56": {
      "instruction": "LSR",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x57": {
      "instruction": "SRE",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x58": {
      "instruction": "CLI",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x59": {
      "instruction": "EOR",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x5A": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x5B": {
      "instruction": "SRE",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 7
    },
    "0x5C": {
      "instruction": "NOP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x5D": {
      "instruction": "EOR",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x5E": {
      "instruction": "LSR",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x5F": {
      "instruction": "SRE",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x60": {
      "instruction": "RTS",
      "mode": "implied",
      "bytes": 1,
      "cycles": 6
    },
    "0x61": {
      "instruction": "ADC",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0x62": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x63": {
      "instruction": "RRA",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 8
    },
    "0x64": {
      "instruction": "NOP",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x65": {
      "instruction": "ADC",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x66": {
      "instruction": "ROR",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x67": {
      "instruction": "RRA",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0x68": {
      "instruction": "PLA",
      "mode": "implied",
      "bytes": 1,
      "cycles": 4
    },
    "0x69": {
      "instruction": "ADC",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x6A": {
      "instruction": "ROR",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x6B": {
      "instruction": "ARR",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x6C": {
      "instruction": "JMP",
      "mode": "indirect",
      "bytes": 3,
      "cycles": 5
    },
    "0x6D": {
      "instruction": "ADC",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x6E": {
      "instruction": "ROR",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x6F": {
      "instruction": "RRA",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0x70": {
      "instruction": "BVS",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0x71": {
      "instruction": "ADC",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0x72": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x73": {
      "instruction": "RRA",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 8
    },
    "0x74": {
      "instruction": "NOP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x75": {
      "instruction": "ADC",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x76": {
      "instruction": "ROR",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x77": {
      "instruction": "RRA",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0x78": {
      "instruction": "SEI",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x79": {
      "instruction": "ADC",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x7A": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x7B": {
      "instruction": "RRA",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 7
    },
    "0x7C": {
      "instruction": "NOP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x7D": {
      "instruction": "ADC",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0x7E": {
      "instruction": "ROR",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x7F": {
      "instruction": "RRA",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0x80": {
      "instruction": "NOP",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x81": {
      "instruction": "STA",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0x82": {
      "instruction": "NOP",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x83": {
      "instruction": "SAX",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0x84": {
      "instruction": "STY",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x85": {
      "instruction": "STA",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x86": {
      "instruction": "STX",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x87": {
      "instruction": "SAX",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0x88": {
      "instruction": "DEY",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x89": {
      "instruction": "NOP",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x8A": {
      "instruction": "TXA",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x8B": {
      "instruction": "XAA",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0x8C": {
      "instruction": "STY",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x8D": {
      "instruction": "STA",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x8E": {
      "instruction": "STX",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x8F": {
      "instruction": "SAX",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0x90": {
      "instruction": "BCC",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0x91": {
      "instruction": "STA",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 6
    },
    "0x92": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x93": {
      "instruction": "AHX",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 6
    },
    "0x94": {
      "instruction": "STY",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x95": {
      "instruction": "STA",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0x96": {
      "instruction": "STX",
      "mode": "zeroPageY",
      "bytes": 2,
      "cycles": 4
    },
    "0x97": {
      "instruction": "SAX",
      "mode": "zeroPageY",
      "bytes": 2,
      "cycles": 4
    },
    "0x98": {
      "instruction": "TYA",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x99": {
      "instruction": "STA",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 5
    },
    "0x9A": {
      "instruction": "TXS",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0x9B": {
      "instruction": "TAS",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 5
    },
    "0x9C": {
      "instruction": "SHY",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 5
    },
    "0x9D": {
      "instruction": "STA",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 5
    },
    "0x9E": {
      "instruction": "SHX",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 5
    },
    "0x9F": {
      "instruction": "AHX",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 5
    },
    "0xA0": {
      "instruction": "LDY",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xA1": {
      "instruction": "LDA",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0xA2": {
      "instruction": "LDX",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xA3": {
      "instruction": "LAX",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0xA4": {
      "instruction": "LDY",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xA5": {
      "instruction": "LDA",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xA6": {
      "instruction": "LDX",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xA7": {
      "instruction": "LAX",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xA8": {
      "instruction": "TAY",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xA9": {
      "instruction": "LDA",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xAA": {
      "instruction": "TAX",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xAB": {
      "instruction": "LAX",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xAC": {
      "instruction": "LDY",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xAD": {
      "instruction": "LDA",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xAE": {
      "instruction": "LDX",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xAF": {
      "instruction": "LAX",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xB0": {
      "instruction": "BCS",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0xB1": {
      "instruction": "LDA",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0xB2": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xB3": {
      "instruction": "LAX",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0xB4": {
      "instruction": "LDY",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0xB5": {
      "instruction": "LDA",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0xB6": {
      "instruction": "LDX",
      "mode": "zeroPageY",
      "bytes": 2,
      "cycles": 4
    },
    "0xB7": {
      "instruction": "LAX",
      "mode": "zeroPageY",
      "bytes": 2,
      "cycles": 4
    },
    "0xB8": {
      "instruction": "CLV",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xB9": {
      "instruction": "LDA",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xBA": {
      "instruction": "TSX",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xBB": {
      "instruction": "LAS",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xBC": {
      "instruction": "LDY",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xBD": {
      "instruction": "LDA",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xBE": {
      "instruction": "LDX",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xBF": {
      "instruction": "LAX",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xC0": {
      "instruction": "CPY",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xC1": {
      "instruction": "CMP",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0xC2": {
      "instruction": "NOP",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xC3": {
      "instruction": "DCP",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 8
    },
    "0xC4": {
      "instruction": "CPY",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xC5": {
      "instruction": "CMP",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xC6": {
      "instruction": "DEC",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0xC7": {
      "instruction": "DCP",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0xC8": {
      "instruction": "INY",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xC9": {
      "instruction": "CMP",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xCA": {
      "instruction": "DEX",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xCB": {
      "instruction": "AXS",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xCC": {
      "instruction": "CPY",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xCD": {
      "instruction": "CMP",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xCE": {
      "instruction": "DEC",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0xCF": {
      "instruction": "DCP",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0xD0": {
      "instruction": "BNE",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0xD1": {
      "instruction": "CMP",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0xD2": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xD3": {
      "instruction": "DCP",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 8
    },
    "0xD4": {
      "instruction": "NOP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0xD5": {
      "instruction": "CMP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0xD6": {
      "instruction": "DEC",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0xD7": {
      "instruction": "DCP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0xD8": {
      "instruction": "CLD",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xD9": {
      "instruction": "CMP",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xDA": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xDB": {
      "instruction": "DCP",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 7
    },
    "0xDC": {
      "instruction": "NOP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xDD": {
      "instruction": "CMP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xDE": {
      "instruction": "DEC",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0xDF": {
      "instruction": "DCP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0xE0": {
      "instruction": "CPX",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xE1": {
      "instruction": "SBC",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 6
    },
    "0xE2": {
      "instruction": "NOP",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xE3": {
      "instruction": "ISC",
      "mode": "indexedIndirect",
      "bytes": 2,
      "cycles": 8
    },
    "0xE4": {
      "instruction": "CPX",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xE5": {
      "instruction": "SBC",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 3
    },
    "0xE6": {
      "instruction": "INC",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0xE7": {
      "instruction": "ISC",
      "mode": "zeroPage",
      "bytes": 2,
      "cycles": 5
    },
    "0xE8": {
      "instruction": "INX",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xE9": {
      "instruction": "SBC",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xEA": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xEB": {
      "instruction": "SBC",
      "mode": "immediate",
      "bytes": 2,
      "cycles": 2
    },
    "0xEC": {
      "instruction": "CPX",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xED": {
      "instruction": "SBC",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 4
    },
    "0xEE": {
      "instruction": "INC",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0xEF": {
      "instruction": "ISC",
      "mode": "absolute",
      "bytes": 3,
      "cycles": 6
    },
    "0xF0": {
      "instruction": "BEQ",
      "mode": "implied",
      "bytes": 2,
      "cycles": 2
    },
    "0xF1": {
      "instruction": "SBC",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 5,
      "pageCross": true
    },
    "0xF2": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xF3": {
      "instruction": "ISC",
      "mode": "indirectIndexed",
      "bytes": 2,
      "cycles": 8
    },
    "0xF4": {
      "instruction": "NOP",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0xF5": {
      "instruction": "SBC",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 4
    },
    "0xF6": {
      "instruction": "INC",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0xF7": {
      "instruction": "ISC",
      "mode": "zeroPageX",
      "bytes": 2,
      "cycles": 6
    },
    "0xF8": {
      "instruction": "SED",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xF9": {
      "instruction": "SBC",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xFA": {
      "instruction": "NOP",
      "mode": "implied",
      "bytes": 1,
      "cycles": 2
    },
    "0xFB": {
      "instruction": "ISC",
      "mode": "absoluteY",
      "bytes": 3,
      "cycles": 7
    },
    "0xFC": {
      "instruction": "NOP",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xFD": {
      "instruction": "SBC",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 4,
      "pageCross": true
    },
    "0xFE": {
      "instruction": "INC",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    },
    "0xFF": {
      "instruction": "ISC",
      "mode": "absoluteX",
      "bytes": 3,
      "cycles": 7
    }
  }
}
